// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"95df79ec","239":"d1d1ff10","453":"32c059f1","732":"2a06f16b","867":"c4242215"}[chunkId] + ".chunk.js";
};